import { render, staticRenderFns } from "./PageSeckill.vue?vue&type=template&id=10e03723&scoped=true"
import script from "./PageSeckill.vue?vue&type=script&lang=js"
export * from "./PageSeckill.vue?vue&type=script&lang=js"
import style0 from "./PageSeckill.vue?vue&type=style&index=0&id=10e03723&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e03723",
  null
  
)

export default component.exports